import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { useTranslations } from '@lang';
import ForgottenPasswordForm from '@features/account/pages/ForgottenPassword/components/ForgottenPasswordForm';
import {
  Background,
  Content,
  FormInstruction,
  Heading,
  SectionContainer,
} from '@common/components/AuthLayout/Layout';

import { resetGuestPassword } from '@store/guest/actions';
import { entitySelectors } from '@store/entity/selectors';

export const ForgottenPasswordContainer = ({ homepage = null, resetGuestPassword, propertyId }) => {
  const { t } = useTranslations();

  return (
    <SectionContainer>
      <Background
        src={homepage && homepage.heroBackgroundImage && homepage.heroBackgroundImage.url}
      />
      <Content>
        <Heading>{t('forgottenPassword.header')}</Heading>
        <FormInstruction>{t('forgottenPassword.description')}</FormInstruction>
        <ForgottenPasswordForm onSubmit={(data) => resetGuestPassword(propertyId, data)} />
      </Content>
    </SectionContainer>
  );
};
ForgottenPasswordContainer.propTypes = {
  homepage: PropTypes.shape({
    heroBackgroundImage: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  resetGuestPassword: PropTypes.func.isRequired,
  propertyId: PropTypes.number.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { homepage } = entitySelectors.getProperty(state, ownProps.id);

  const homepageId = homepage ? homepage.id : null;
  return {
    homepage: entitySelectors.getHomepage(state, homepageId),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetGuestPassword,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ForgottenPasswordContainer);
